import { ThemeContext } from "../contexts/ThemeManager";
import { LiftTheme } from "../theme";
import { useIsScreenSizeMin } from "./useIsScreenSizeMin";
import { use, useMemo } from "react";

export const useTheme = () => {
    const theme = use(ThemeContext);
    const isLarge = useIsScreenSizeMin("large");
    const gridSize = useMemo(() => (isLarge ? 36 : 24), [isLarge]);

    return {
        ...theme,
        gridSize,
        marginSize: (2 / 3) * gridSize, // 2/3 of gridSize
    } as LiftTheme;
};
